import { GetServerSidePropsContext } from 'next';
import { AccountSignIn, MinimalLayout } from '@honeycomb/ui';
import { getPageAndGlobalProps } from '@honeycomb/data';
import { Logo } from 'components/Logo';
import { Masthead } from 'components/Masthead';

export default function SignIn(): React.JSX.Element {
    return <AccountSignIn socialMediaLogin={false} />;
}

SignIn.getLayout = (page: React.ReactElement, props: Record<string, unknown>) => {
    return (
        <MinimalLayout logo={<Logo />} masthead={<Masthead reduced={true} />} {...props}>
            {page}
        </MinimalLayout>
    );
};

export const getServerSideProps = (context: GetServerSidePropsContext) => {
    return getPageAndGlobalProps(context);
};
